// A modal dialog on the dispatch-plan page (the publish and clear
// confirmations, the order selector): focus starts on its heading, Escape
// cancels. Its content describes itself with id="plan-dialog-desc".

import { type ReactNode, useEffect, useRef } from "react";

export function Dialog({
  title,
  busy,
  onCancel,
  wide = false,
  children,
}: {
  title: string;
  busy: boolean;
  onCancel: () => void;
  wide?: boolean;
  children: ReactNode;
}) {
  const heading = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    heading.current?.focus();
  }, []);

  // On the document, so Escape still works after the focused control went away.
  useEffect(() => {
    const escape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) onCancel();
    };
    document.addEventListener("keydown", escape);
    return () => document.removeEventListener("keydown", escape);
  }, [busy, onCancel]);

  return (
    <div className="plan-dialog-backdrop">
      <div
        className={`plan-dialog${wide ? " is-wide" : ""}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="plan-dialog-h"
        aria-describedby="plan-dialog-desc"
      >
        <h3 id="plan-dialog-h" tabIndex={-1} ref={heading}>
          {title}
        </h3>
        {children}
      </div>
    </div>
  );
}
